import { createRef, ReactElement, useMemo } from 'react'
import { TextField } from '@machobear/design-system'
import { useField } from 'formik'
import noop from 'lodash/noop'

import useFocusOnError from '@/hooks/use-focus-on-error'

const identity = (v: any) => v

export const FieldInput = ({
  name,
  label,
  onChange = noop,
  onBlur = noop,
  maxLength,
  required = false,
  mask = identity,
  disabled = false,
  type = 'text'
}: {
  name: string
  label: string
  onChange?: any
  onBlur?: any
  maxLength?: number
  required?: boolean
  mask?: any
  disabled?: boolean
  type?: 'number' | 'text' | 'search' | 'tel' | 'url' | 'email' | 'password'
  actionIcon?: ReactElement
  onAction?: () => void
  prefix?: string
  autoComplete?: string
  actionLabel?: string
}) => {
  const fieldRef = createRef<HTMLInputElement>()
  const [field, meta] = useField(name)
  const { error, touched } = meta
  const { value, onChange: formikOnChange, onBlur: formikOnBlur } = field
  useFocusOnError({ fieldRef, name })

  const onChangeField = (e: any) => {
    onChange(e)
    formikOnChange(e)
  }

  const onBlurField = (e: any) => {
    onBlur(e)
    formikOnBlur(e)
  }

  const maskedValue = useMemo(() => mask(value), [value, mask])

  return (
    <TextField
      ref={fieldRef}
      id={name}
      name={name}
      value={maskedValue}
      onChange={onChangeField}
      onBlur={onBlurField}
      label={label}
      required={required}
      maxLength={maxLength}
      disabled={disabled}
      message={error && touched ? error : null}
      tone={error && touched ? 'critical' : 'neutral'}
      type={type}
      placeholder={label}
    />
  )
}
